import { render, staticRenderFns } from "./BirthDay.vue?vue&type=template&id=47ea909c&scoped=true&"
import script from "./BirthDay.vue?vue&type=script&lang=js&"
export * from "./BirthDay.vue?vue&type=script&lang=js&"
import style0 from "./BirthDay.vue?vue&type=style&index=0&id=47ea909c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea909c",
  null
  
)

export default component.exports